"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/GIFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_88)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_88`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 16.1404H30V24H-6V16.1404Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M19.4807 9.24908V6.95434H20.2456V5.42452H18.7087V6.18943H17.1789V5.42452H15.6491V6.95434H16.414V9.24908H14.8842V3.89469H15.6491V2.36487H14.1193V3.12978H13.3544V2.36487H11.8245V3.12978H11.0596V2.36487H9.5298V3.89469H10.2947V9.24908H8.76489V6.95434H9.5298V5.42452H7.99998V6.18943H6.47015V5.42452H4.94033V6.95434H5.70524V9.24908H4.17542V15.3684H21.0105V9.24908H19.4807Z",
					fill: "#D80027",
					stroke: "black",
					strokeWidth: .0701754,
					strokeMiterlimit: 10
				}),
				/* @__PURE__ */ n("path", {
					d: "M12.5895 16.5264L10.8912 17.8036L12.2316 18.8071V21.0036H10.6035V21.6351H12.2176V22.1895H10.6035V22.8422H12.9474V18.8071L14.2877 17.8036L12.5895 16.5264ZM12.5895 18.3018L11.8807 17.8036L12.5895 17.3053L13.2983 17.8036L12.5895 18.3018Z",
					fill: "#FFDA44",
					stroke: "black",
					strokeWidth: .0701754,
					strokeMiterlimit: 10
				}),
				/* @__PURE__ */ n("path", {
					d: "M10.814 14.7158V12.7579C10.814 12.7579 10.821 11.193 12.5684 11.193C14.3088 11.193 14.3719 12.7369 14.3719 12.7369V14.7158H10.814ZM5.9649 14.7158V13.0105C5.9649 13.0105 5.97192 11.6983 7.34034 11.6983C8.70876 11.6983 8.75789 12.9895 8.75789 12.9895V14.7088H5.9649V14.7158Z",
					fill: "black"
				}),
				/* @__PURE__ */ n("path", {
					d: "M5.86664 14.7158V13.0105C5.86664 13.0105 5.87366 11.6983 7.24208 11.6983C8.6105 11.6983 8.65962 12.9895 8.65962 12.9895V14.7088H5.86664V14.7158ZM16.5193 14.7158V13.0105C16.5193 13.0105 16.5263 11.6983 17.8947 11.6983C19.2631 11.6983 19.3123 12.9895 19.3123 12.9895V14.7088H16.5193V14.7158ZM17.1087 9.26316V8.16141C17.1087 8.16141 17.1158 7.31229 17.9017 7.31229C18.6947 7.31229 18.7228 8.14737 18.7228 8.14737V9.26316H17.1087ZM11.5789 9.26316V7.60001C11.5789 7.60001 11.5859 6.3158 12.5824 6.3158C13.5789 6.3158 13.614 7.57895 13.614 7.57895V9.26316H11.5789ZM6.45611 9.26316V8.16141C6.45611 8.16141 6.46313 7.31229 7.24909 7.31229C8.03506 7.31229 8.07015 8.14737 8.07015 8.14737V9.26316H6.45611Z",
					fill: "black"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_88`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as GIFlag };
